import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Form, Button, Alert, Spinner } from 'react-bootstrap';
import { adminApi, extractError } from '../api/client';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    if (!email) { setError('Email is required.'); return; }
    setSubmitting(true);
    try {
      await adminApi.post('/auth/forgot-password', { email: email.trim().toLowerCase() });
      setSent(true);
    } catch (err) {
      setError(extractError(err));
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="login-shell">
      <div className="login-card" data-testid="forgot-password-card">
        <div className="login-brand">
          <span className="brand-mark">NV</span>
          <div>
            <div style={{ fontWeight: 700, fontFamily: 'var(--font-heading)' }}>National Voter Guide</div>
            <div className="text-muted" style={{ fontSize: '0.85rem' }}>Reset your password</div>
          </div>
        </div>

        {sent ? (
          <>
            <h2 style={{ fontSize: '1.3rem', marginBottom: 6 }}>Check your email</h2>
            <Alert variant="success" data-testid="forgot-password-success">
              If an account exists for <strong>{email}</strong>, a reset link has been sent. The link will expire in 60 minutes.
            </Alert>
            <div className="d-flex justify-content-between">
              <Link to="/login" className="text-decoration-none">&larr; Back to sign in</Link>
              <Button variant="link" size="sm" onClick={() => { setSent(false); setEmail(''); }} className="p-0" data-testid="forgot-password-resend-button">
                Send to a different email
              </Button>
            </div>
          </>
        ) : (
          <>
            <h2 style={{ fontSize: '1.3rem', marginBottom: 6 }}>Forgot password?</h2>
            <p className="text-muted" style={{ fontSize: '0.9rem', marginBottom: 22 }}>
              Enter the email associated with your account and we'll send you a secure reset link.
            </p>

            {error && <Alert variant="danger" data-testid="forgot-password-error">{error}</Alert>}

            <Form onSubmit={handleSubmit} noValidate>
              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  autoFocus
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  data-testid="forgot-password-email-input"
                />
              </Form.Group>
              <Button type="submit" variant="primary" className="w-100" disabled={submitting} data-testid="forgot-password-submit-button">
                {submitting ? <><Spinner size="sm" animation="border" /> Sending…</> : 'Send reset link'}
              </Button>
              <div className="mt-3 text-center">
                <Link to="/login" className="text-decoration-none" style={{ fontSize: '0.88rem' }}>&larr; Back to sign in</Link>
              </div>
            </Form>
          </>
        )}
      </div>
    </div>
  );
}
